/**
 *
 * This is a loading wrapper to load all required data / assets before showing children.
 * This has potential to be more abstract but for now keep it specific to insights needs.
 *
 *
 * @author Matthew Rawson @ 03/05/2018 17:13
 * @description
 * @notes
 */
import React, {Component} from "react"
import PropTypes from "prop-types"
import {withApollo} from "react-apollo"
import {withRouter} from "react-router-dom"

import {insGlobalMutation} from "@irati/insights/apollo/client/mutation/insGlobal"
import id from "@irati/utils/id"
import intercom from "@irati/utils/intercom"
import {InsightsDemoTenantQuery} from "@irati/insights/apollo/query/demo-tenant"
import {DemoTenantContext} from "@irati/insights/context"
import authentication from "@irati/auth"
import clientConfig from "@irati/insights/apollo/client"

import ReportStatusCheck from "../Report/ReportStatusCheck"

const POLL_INTERVAL_MINUTES = 10

class RequiredByInsights extends Component {
  static propTypes = {
    children: PropTypes.node,
    client: PropTypes.object.isRequired
  }
  static defaultProps = {
    children: null
  }

  constructor(props) {
    super(props)
    clientConfig.setup(props.client)
  }

  componentDidMount() {
    intercom.hide()
    this.saveRequiredParamsToState(this.props)
  }

  saveRequiredParamsToState = (props) => {
    const {client} = props
    const tenant = authentication.userTenant().uuid
    const variables = {params: {tenant}}
    client.mutate({mutation: insGlobalMutation, variables})
  }

  render() {
    const idNamespace = id("RequiredByInsights", this.props)
    const {children, client} = this.props

    return (
      <div id={idNamespace}>
        <InsightsDemoTenantQuery
          locale={authentication.userLocale()}
          fetchPolicy="network-only"
          pollInterval={POLL_INTERVAL_MINUTES * 60000}
          onCompleted={({insightsDemoTenant = {}}) => {
            client.cache.writeData({data: {insDemo: insightsDemoTenant}})
          }}>
          {({insightsDemoTenant}) => (
            <DemoTenantContext.Provider value={insightsDemoTenant}>
              <>
                <ReportStatusCheck />
                {children}
              </>
            </DemoTenantContext.Provider>
          )}
        </InsightsDemoTenantQuery>
      </div>
    )
  }
}

export default withApollo(withRouter(RequiredByInsights))
